const READING_LABELS: Record<string, string> = {
  unread: "Unread",
  skimmed: "Skimmed",
  read: "Read",
};

export function readingLabel(status: string): string {
  return READING_LABELS[status] ?? status.charAt(0).toUpperCase() + status.slice(1);
}

/** Why an automatically set reading status was set (spec 2026-06-07,
 * amended 2026-09-27), or null when the status wasn't set by automation. */
export function autoReadingNote(status: string, source: string | null | undefined): string | null {
  if (source !== "auto") return null;
  if (status === "skimmed") return "Marked skimmed automatically: the full text was open ≥15s or 2 pages";
  if (status === "read") return "Marked read automatically: ≥3 pages and 90s in the PDF";
  return null;
}
